import clsx from "clsx";
import { HashLink as Link } from "react-router-hash-link";
import styles from "./TutorialButton.module.scss";

interface Props {
  children: React.ReactNode;
  to: string;
  variant?: "primary" | "outline";
  size?: "sm" | "md" | "lg";
  offsite?: boolean;
}

export function TutorialButton(props: Props) {
  const variantStyles = styles[props.variant || "primary"];
  const sizeStyles = styles[props.size || "lg"];
  return props.offsite ? (
    <a
      className={clsx(styles.btn, variantStyles, sizeStyles)}
      href={props.to}
      target="_blank"
      rel="noopener noreferrer"
    >
      {props.children}
    </a>
  ) : (
    <Link
      className={clsx(styles.btn, variantStyles, sizeStyles)}
      to={props.to}
      smooth
    >
      {props.children}
    </Link>
  );
}
